import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import ContractorsPage from './components/ContractorsPage';
import ContractorForm from './components/ContractorsPage/components/ContractorForm';
import styles from './styles';
import { drawerTypes } from '../Equipment/components/helpers/drawerTypes';
import ContractorsHeader from './components/ContractorsHeader/ContractorsHeader';
import SnackBar from 'components/SnackBar';
import { useDispatch } from 'react-redux';
import { getLocations } from 'store/settings/settingsOperations';
import InfoDialog from 'components/InfoDialog/InfoDialog';
import { useBootstrapLaborClassifications } from 'store/laborClassifications';

const Contractors = ({ classes }) => {
  const dispatch = useDispatch();
  useBootstrapLaborClassifications();
  const [drawer, setDrawer] = useState({
    type: drawerTypes.create,
    isOpen: false,
  });

  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    text: '',
    type: 'success',
  });
  const [displayProjectsAssignedError, setDisplayProjectsAssignedError] = useState({ isOpen: false })

  useEffect(() => {
    dispatch(getLocations());
  })

  const openSnackbar = (type, text) => setSnackbar({ isOpen: true, type, text });
  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, isOpen: false }));

  const openDrawer = (type, open) => () => {
    setDrawer({ type, isOpen: open });
  };

  const closeDrawer = () => {
    setDrawer((prev) => ({ ...prev.drawer, isOpen: false }));
  };


  const getDisplayProjectsAssignedErrorMessage = () => {
    if (!displayProjectsAssignedError?.locations?.length || !displayProjectsAssignedError?.projects) {
      return '';
    }
    const locations = displayProjectsAssignedError?.locations;
    const projects = displayProjectsAssignedError?.projects;

    return `The contractor is assigned to the following active project(s) in the location(s) ${locations?.join(', ')}:
${projects?.join(', ')}.
A contractor cannot be unassigned from a location while they have active projects assigned to it.`
  }

  console.log('displayProjectsAssignedError: ', displayProjectsAssignedError);

  return (
    <div className={classes.root}>
      <ContractorsHeader openDrawer={openDrawer} type={'Contractors'} />
      <ContractorsPage
        openSnackbar={openSnackbar}
        classes={classes}
        setDisplayProjectsAssignedError={setDisplayProjectsAssignedError}
      />
      <Drawer
        anchor="right"
        open={drawer.isOpen}
        classes={{
          paper: classes.drawer,
        }}
      >
        <ContractorForm
          closeDrawer={closeDrawer}
          openSnackbar={openSnackbar}
          type={drawer.type}
        />
      </Drawer>
      {(displayProjectsAssignedError?.isOpen) ? (
        <InfoDialog
          isOpen={displayProjectsAssignedError?.isOpen}
          onClose={() => setDisplayProjectsAssignedError({ isOpen: false })}
          title="Contractor Has Active Projects"
          message={getDisplayProjectsAssignedErrorMessage()}
          btnText="Close"
        />
      ) : null}
      <SnackBar closeSnackbar={closeSnackbar} {...snackbar} />
    </div>
  );
};

Contractors.propTypes = {
  classes: propTypes.object.isRequired,
  openSnackbar: propTypes.func.isRequired,
};

export default withStyles(styles)(Contractors);
